export default {"src":"/_next/static/media/4.5097a3ae.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};